import { ChevronRightSVG } from '@sbercloud/uikit-product-icons';
import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { ButtonFunction, ButtonFunctionProps } from '@snack-uikit/button';

import styles from './styles.module.scss';

type FooterItem = {
  label: string;
  href?: string;
  onClick?: ButtonFunctionProps['onClick'];
  //TODO: удалить после тестирования
  dataAttr?: string;
};

export type SectionCatalogFooterProps = WithLayoutType<{
  items: FooterItem[];
}>;

export function SectionCatalogWithSearchFooter({
  items,
  layoutType,
}: SectionCatalogFooterProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={styles.footer} data-layout-type={layoutType}>
      {items.map(({ label, onClick, href, dataAttr }) => (
        <ButtonFunction
          key={label}
          label={label}
          size="m"
          onClick={onClick}
          href={href}
          icon={<ChevronRightSVG />}
          data-attr={dataAttr}
        />
      ))}
    </div>
  );
}
